
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.container {margin-bottom: 1rem;display: flex;flex-direction: column;flex-wrap: wrap;justify-content: flex-start;gap: 0.5rem
}@media (min-width: 480px) {.container {flex-direction: row
  }
}@media (min-width: 1024px) {.container {justify-content: space-between
  }
}.container.show-less idb-toggle-view {width: 100%
}.container.show-less idb-toggle-view {min-width: 180px
}@media (min-width: 480px) {.container.show-less idb-toggle-view {width: 49%
  }
}@media (min-width: 640px) {.container.show-less idb-toggle-view {width: 32%
  }
}@media (min-width: 1024px) {.container.show-less idb-toggle-view {width: 19%
  }
}.container.show-more idb-toggle-view {width: 100%
}@media (min-width: 640px) {.container.show-more idb-toggle-view {width: 49%
  }
}

.info-group {display: flex;min-height: 5rem;align-items: center;gap: 1rem;border-radius: 0.75rem;background-color: var(--blue-responsible-lighten-6);padding-left: 1rem;padding-right: 1rem;padding-top: 0.5rem;padding-bottom: 0.5rem;color: var(--neutral-white);
}

.info-group .indicator {display: flex
}

.info-group .indicator {width: 50%
}

.info-group .indicator {align-items: center
}

.info-group .indicator {gap: 1rem
}

.info-group .collapse {margin-left: auto
}

.info-group .collapse {cursor: pointer
}

.info-group .collapse {border-radius: 9999px
}

.info-group .collapse {background-color: var(--cyan-near-main)
}

.info-group .collapse {padding: 1.5rem
}

.info-group .collapse {transition-property: all;transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);transition-duration: 150ms
}

.info-group.show-more .collapse {--tw-rotate: 180deg;transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.description {margin: 1rem;color: var(--blue-responsible-main)
}`;